import TRANSLATIONS from "./translate/translations.json";

export default function translate(str) {
    let lookup = str;
    if (str.includes('The current user cannot perform operations on cart')) {
        lookup = 'The current user cannot perform operations on cart';
    }
    return TRANSLATIONS[lookup] ?? str;
}
